<template>
    <div :class="classes" @click="toggleEditMode">
        <template v-if="!editMode">
            <CompassSkeleton v-if="loading" size="x-large" />
            <div v-else class="edit-simple-date__value">
                <CompassIcon size="small" icon="calendar-fill" />
                <span class="typographies-paragraph-medium-regular">
                    {{ formattedDate }}
                </span>
            </div>
        </template>
        <CompassDatePicker
            v-else
            :value="localDate"
            :formatDateDisplayed="dateFormat"
            :lang="uiLang"
            :calendarOptions="{ value: localDate }"
            :openCalendar="true"
            @update:value="handleValueUpdate"
            @close="editMode = false"
        />
    </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState } = createNamespacedHelpers('corp');

export default {
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        date: {
            type: String,
            default: null,
        },
        canEdit: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            editMode: false,
            localDate: '',
        };
    },
    computed: {
        ...mapState(['uiLang', 'timeformat']),
        dateFormat() {
            return this.timeformat === 'mdy' ? 'MM/DD/YYYY' : 'DD/MM/YYYY';
        },
        formattedDate() {
            return moment(this.date).format(this.dateFormat);
        },
        classes() {
            return {
                'edit-simple-date': true,
                'edit-simple-date--editable': this.canEdit,
            };
        },
    },
    watch: {
        date(value) {
            this.localDate = value ? moment(value).format('YYYY-MM-DD') : '';
        },
    },
    created() {
        this.localDate = this.date ? moment(this.date).format('YYYY-MM-DD') : '';
    },
    methods: {
        toggleEditMode() {
            if (!this.editMode && this.canEdit) {
                this.editMode = true;
            }
        },
        handleValueUpdate(value) {
            this.$emit('update', value);
            this.editMode = false;
        },
    },
};
</script>
<style scoped lang="scss">
.edit-simple-date {
    position: relative;

    &--editable {
        .edit-simple-date__value {
            &:before {
                content: '';
                background: var(--colors-common-background-primary-hover-alt);
                border-radius: 2px;
                bottom: 0;
                display: none;
                left: -4px;
                position: absolute;
                right: -4px;
                top: 0;
            }

            &:hover {
                &:before {
                    display: block;
                }
            }
        }
    }

    &__value {
        align-items: center;
        display: flex;
        gap: var(--spacing-0);
        min-height: 32px;
    }

    &::v-deep {
        .compass-datepicker .compass-input {
            min-width: 140px;

            input {
                width: 10ch;
            }
        }
    }
}
</style>
